export const DEFAULT_COMPANY_ID = "14";
export const BOOKMAKER_LOGO_BASE = "assets/images/bookmakers/";

export type Bookmaker = {
  id: string;
  name: string;
  logo: string;
};

export const BOOKMAKERS: Record<string, Bookmaker> = {
  "2": { id: "2", name: "BET365", logo: `${BOOKMAKER_LOGO_BASE}bet365.svg` },
  "3": { id: "3", name: "CROWN", logo: `${BOOKMAKER_LOGO_BASE}crown.svg` },
  "4": { id: "4", name: "TENBET", logo: `${BOOKMAKER_LOGO_BASE}tenbet.svg` },
  "5": { id: "5", name: "LADBROKES", logo: `${BOOKMAKER_LOGO_BASE}ladbrokes.svg` },
  "6": { id: "6", name: "MANSION88", logo: `${BOOKMAKER_LOGO_BASE}mansion88.svg` },
  "7": { id: "7", name: "MACAUSLOT", logo: `${BOOKMAKER_LOGO_BASE}macauslot.svg` },
  "8": { id: "8", name: "SNAI", logo: `${BOOKMAKER_LOGO_BASE}snai.svg` },
  "9": { id: "9", name: "WILLHILL", logo: `${BOOKMAKER_LOGO_BASE}willhill.svg` },
  "10": { id: "10", name: "EASYBETS", logo: `${BOOKMAKER_LOGO_BASE}easybets.svg` },
  "11": { id: "11", name: "VCBET", logo: `${BOOKMAKER_LOGO_BASE}vcbet.svg` },
  "12": { id: "12", name: "EUROBET", logo: `${BOOKMAKER_LOGO_BASE}eurobet.svg` },
  "13": { id: "13", name: "INTERWETTEN", logo: `${BOOKMAKER_LOGO_BASE}interwetten.svg` },
  "14": { id: "14", name: "BET12", logo: `${BOOKMAKER_LOGO_BASE}bet12.svg` },
  "15": { id: "15", name: "SBOBET", logo: `${BOOKMAKER_LOGO_BASE}sbobet.svg` },
  "16": { id: "16", name: "WEWBET", logo: `${BOOKMAKER_LOGO_BASE}wewbet.svg` },
  "17": { id: "17", name: "BET18", logo: `${BOOKMAKER_LOGO_BASE}bet18.svg` },
  "18": { id: "18", name: "FUN88", logo: `${BOOKMAKER_LOGO_BASE}fun88.svg` },
  "21": { id: "21", name: "BET188", logo: `${BOOKMAKER_LOGO_BASE}bet188.svg` },
  "22": { id: "22", name: "PINNACLE", logo: `${BOOKMAKER_LOGO_BASE}pinnacle.svg` },
  "136": { id: "136", name: "HKJC", logo: `${BOOKMAKER_LOGO_BASE}hkjc.svg` },
};
